import Enable2FaModal from './Enable2FaModal.component';

export default Enable2FaModal;